// @ts-nocheck
import { replaceAllNotHexadecimalTextCursor } from '../replaceWithCursorPosition';

export class MaskIPv6 {
  public insertIconValidate = true;
  public validateAllDigit = false;

  public maxLength = 39;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotHexadecimalTextCursor(
      value,
      cursorPosition
    );

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      const cases = {
        case0: /^([0-9a-fA-F]{4})([0-9a-fA-F]{1})$/,
        case1: /^([0-9a-fA-F]{1,4}):([0-9a-fA-F]{4})([0-9a-fA-F]{1})$/,
        case2: /^([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{4})([0-9a-fA-F]{1})$/,
        case3:
          /^([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{4})([0-9a-fA-F]{1})$/,
        case4:
          /^([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{4})([0-9a-fA-F]{1})$/,
        case5:
          /^([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{4})([0-9a-fA-F]{1})$/,
        case6:
          /^([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{4})([0-9a-fA-F]{1})$/,
        case7:
          /^([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{1,4})([0-9a-fA-F]{4})([0-9a-fA-F]{1,4})$/,
      };

      if (value.match(cases.case0)) {
        const formatedValue = value.replace(cases.case0, '$1:$2');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case1)) {
        const formatedValue = value.replace(cases.case1, '$1:$2:$3');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case2)) {
        const formatedValue = value.replace(cases.case2, '$1:$2:$3:$4');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case3)) {
        const formatedValue = value.replace(cases.case3, '$1:$2:$3:$4:$5');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case4)) {
        const formatedValue = value.replace(cases.case4, '$1:$2:$3:$4:$5:$6');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case5)) {
        const formatedValue = value.replace(cases.case5, '$1:$2:$3:$4:$5:$6:$7');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case6)) {
        const formatedValue = value.replace(cases.case6, '$1:$2:$3:$4:$5:$6:$7:$8');
        const formatedCursorPosition =
          cursorPosition >= value.length - 1 ? cursorPosition + 1 : cursorPosition;
        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      } else if (value.match(cases.case7)) {
        const formatedValue = value.replace(cases.case7, '$1:$2:$3:$4:$5:$6:$7:$8');
        return { formatedValue, formatedCursorPosition: cursorPosition };
      } else {
        return { formatedValue: value, formatedCursorPosition: cursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }
  public validate(value) {
    return value.match(
      /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/
    );
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['IPv6']];
  }
}
